export const LOOK_ANNOTATED_TYPE = 'lookProducts'
export const TWINNED_LOOK_TYPE = 'twinnedLooksResults'
export const STYLE_ADVISOR_TYPE = 'styleAdvisorLook'

export const LOOK_TYPE_DESCRIPTION = {
  [LOOK_ANNOTATED_TYPE]: 'Look annotated',
  [TWINNED_LOOK_TYPE]: 'Twinned look',
  [STYLE_ADVISOR_TYPE]: 'Style advisor look'
}

export const LOOK_TYPE_ORDER = {
  lookProducts: 1,
  twinnedLooksResults: 2,
  styleAdvisorLook: 3
}

// RT - Recommendation Types
export const RECOMMENDATION_TYPES = {
  PERFECT_MATCH: {
    value: 'perfect_match',
    description: 'Perfect Match'
  },
  SIMILAR: {
    value: 'similar',
    description: 'Similar'
  },
  MAYBE: {
    value: 'maybe',
    description: 'Maybe'
  },
  FITB: {
    value: 'fitb',
    description: 'Fitb'
  },
  NO: {
    value: 'no',
    description: 'No'
  }
}

export const RT_NO_CATREGORIES = {
  OUTWEAR: 'outwear',
  TOP: 'top',
  BOTTOM: 'bottom',
  ONE_PIECE: 'one_piece',
  SHOES: 'shoes',
  BAG: 'bag',
  ACCESSORIES: 'accessories'
}

export const NEW_DETECTION_STR = 'New detection'
export const INTERNAL_REF = 'internal_ref'



// WEBPACK FOOTER //
// ./src/utils/constants.js